var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "RGB",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5000 3570",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #043d2b;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5000 3568.96 0 3568.96 0 1.04 5000 972.93 5000 3568.96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1472.7,1856.26h475.05l-459,1219.71h-638.74l-455.79-1219.71h486.28l295.29,906.75,296.9-906.75Zm441.26,608.25c0-401.22,190.98-633.93,741.45-633.93,232.71,0,446.15,36.91,516.78,78.65v353.07c-65.8-22.47-250.36-60.99-428.51-60.99-253.57,0-372.33,81.85-372.33,266.41,0,197.4,110.74,280.85,369.13,280.85,179.74,0,340.23-32.09,428.5-64.19v333.81c-97.89,52.96-287.27,83.46-518.37,83.46-534.42,0-736.64-232.7-736.64-637.13Zm1349.15,0c0-401.22,190.98-633.93,741.44-633.93,232.72,0,446.16,36.91,516.78,78.65v353.07c-65.8-22.47-250.36-60.99-428.51-60.99-253.57,0-372.33,81.85-372.33,266.41,0,197.4,110.74,280.85,369.13,280.85,179.74,0,340.23-32.09,428.5-64.19v333.81c-97.89,52.96-287.26,83.46-518.37,83.46-534.42,0-736.63-232.7-736.63-637.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcc);
export default __webpack_public_path__ + "static/media/vcc.475f2f76d6d7d8f90251947a5e28a16d.svg";
export { ForwardRef as ReactComponent };